




























































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { storePenunjang } from "@/store/modules/penunjang";
import CardModalItemPenunjang from "@/components/modal/CardModalItemPenunjang.vue";
import DataPenunjang from "@/services/DataPenunjang";
// import User from "@/utility/User";
import Calendar from "@/utility/Calendar";
import _, { isEmpty } from "lodash";
// import { DetailPasien } from "@/models/Pasien";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import CardListTemplatePenunjang from "@/components/modal/CardListTemplatePenunjang.vue";
import { storeCopy } from "@/store/modules/copy";
import { PrioritasOrderLab } from "@/types";

@Component({
  components: {
    CardModalItemPenunjang,
    CardListTemplatePenunjang
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class InputOrderPenunjang extends Vue {
  @Prop() type: string;
  @Prop() register!: string;
  @Prop() rm: string;
  @Prop() detailOrder!: object;
  @Prop() paste: Array<object>;
  @Prop() statusPaste: string;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }
  tab = "daftar-order";
  tglIsi = moment().format("YYYY-MM-DD");
  today = moment().format("YYYY-MM-DD");
  tglShow = false;
  maxDate = moment()
    .add(2, "days")
    .format("YYYY-MM-DD");
  modalOpen = false;
  isSaving = false;
  showModal = false;
  title = "";
  orderItems = [];
  groupItem = [];
  clinical_note = "";
  other_note = "";
  prioritas: PrioritasOrderLab = "reguler";
  sess_login = this.stateuser;
  templateMode = "list";
  showTemplateModal = false;
  statusTemplateModal = false;
  titleTemplate = "";

  // created() {
  //   const max = new Date(new Date().setDate(new Date().getDate() + 3));
  //   this.maxDate = max.toISOString().substring(0, 10);
  // }

  mounted() {
    this.orderItems = this.detailOrder["items"];
    this.prioritas = this.detailOrder["prioritas"] || "reguler";
  }

  @Watch("detailOrder")
  changed(val) {
    // console.log("input", val);

    if (!isEmpty(val)) {
      this.tglIsi = Calendar.formatTgl(val["date"]);
      this.clinical_note = val["clinical_note"];
      this.other_note = val["other_note"];
      this.prioritas = val["prioritas"] || "reguler";
      this.orderItems = val["items"];
    } else {
      this.clinical_note = "";
      this.other_note = "";
      this.prioritas = "reguler";
      this.orderItems = [];
    }
  }

  buatOrder() {
    this.tab = "buat-order";
  }

  get stateuser() {
    return userModule.user;
  }

  get statepenunjanggrouplab() {
    return storePenunjang.penunjangGroupLab;
  }
  get statepenunjanggroupradiologi() {
    return storePenunjang.penunjangGroupRadiologi;
  }
  get tglIsiFormattedMomentjs() {
    return this.tglIsi ? moment(this.tglIsi).format("DD MMMM YYYY") : "";
  }
  showItem() {
    // console.log(this.orderItemsLab)
    if (this.type === "lab") {
      this.showModal = true;
      this.groupItem = this.statepenunjanggrouplab;
      this.title = "Order Laboratorium";
      if (!isEmpty(this.detailOrder)) {
        this.orderItems = this.detailOrder["items"];
      }
      // console.log(this.orderItems)
    } else {
      this.showModal = true;
      this.groupItem = this.statepenunjanggroupradiologi;
      this.title = "Order Radiologi";
      // console.log("orderitem", this.orderItems);
      if (!isEmpty(this.detailOrder)) {
        this.orderItems = this.detailOrder["items"];
      }
    }
  }
  setOrderItems(items) {
    // untuk di list input
    this.orderItems = items;
  }
  removeItem(idx) {
    this.orderItems.splice(idx, 1);
  }

  kirim() {
    if (this.readOnly) return;
    if (this.type === "lab" && !this.prioritas) {
      appModule.sendErrorAlert(
        "Pilih prioritas pemeriksaan: Reguler atau Cito."
      );
      return;
    }
    const items = _.map(this.orderItems, "id");
    appModule.setLoading(true);
    if (isEmpty(this.detailOrder)) {
      // console.log("simpan");
      if (this.type === "lab") {
        const dt = DataPenunjang.saveDataOrderLab(
          this.register,
          this.tglIsi,
          this.sess_login["unit_id"],
          this.rm,
          this.clinical_note,
          this.other_note,
          this.sess_login["id"],
          items,
          this.prioritas
        );
        dt.then(dt => {
          appModule.setLoading(false);
          if (dt["data"]["status"] != 1) {
            // appModule.sendErrorAlert(dt["err"]);
            // console.log("gagal");
          } else {
            appModule.NoticeDelay("Berhasil Order Lab");
            this.prioritas = "reguler";
            this.$emit("pageTab", this.tab);
          }
        });
      } else {
        const dt = DataPenunjang.saveDataOrderRadiologi(
          this.register,
          this.tglIsi,
          this.sess_login["unit_id"],
          this.rm,
          this.clinical_note,
          this.other_note,
          this.sess_login["id"],
          items
        );
        dt.then(dt => {
          appModule.setLoading(false);
          if (dt["data"]["status"] != 1) {
            // appModule.sendErrorAlert(dt["err"]);
            // console.log("gagal");
          } else {
            appModule.NoticeDelay("Berhasil Order Radiologi");
            this.$emit("pageTab", this.tab);
          }
        });
      }
    } else {
      if (this.type === "lab") {
        const dt = DataPenunjang.editDataOrderLab(
          this.detailOrder["id"],
          this.register,
          this.tglIsi,
          this.sess_login["unit_id"],
          this.rm,
          this.clinical_note,
          this.other_note,
          this.sess_login["id"],
          items,
          this.prioritas
        );
        dt.then(dt => {
          appModule.setLoading(false);
          if (dt["data"]["status"] != 1) {
            // appModule.sendErrorAlert(dt["err"]);
            // console.log("gagal");
          } else {
            appModule.NoticeDelay("Berhasil Ubah Order Lab");
            this.prioritas = "reguler";

            this.$emit("pageTab", this.tab);
          }
        });
      } else {
        const dt = DataPenunjang.editDataOrderRadiologi(
          this.detailOrder["id"],
          this.register,
          this.tglIsi,
          this.sess_login["unit_id"],
          this.rm,
          this.clinical_note,
          this.other_note,
          this.sess_login["id"],
          items
        );
        dt.then(dt => {
          appModule.setLoading(false);
          if (dt["data"]["status"] != 1) {
            // appModule.sendErrorAlert(dt["err"]);
            // console.log("gagal");
          } else {
            // console.log("sukses order radiologi");
            // console.log(dt);
            appModule.NoticeDelay("Berhasil Ubah Order Radiologi");

            this.$emit("pageTab", this.tab);
          }
        });
      }
    }
  }
  showInputTemplate() {
    if (this.type == "lab") {
      this.titleTemplate = "Input Template Order Laboratorium";
    } else {
      this.titleTemplate = "Input Template Order Radiologi";
    }
    this.templateMode = "input";
    this.$nextTick(function() {
      this.showTemplateModal = true;
    });
  }
  showListTemplate() {
    if (this.type == "lab") {
      this.titleTemplate = "Daftar Template Order Laboratorium";
    } else {
      this.titleTemplate = "Daftar Template Order Radiologi";
    }

    this.templateMode = "list";
    this.$nextTick(function() {
      this.showTemplateModal = true;
    });
  }
  closeTemplateModal() {
    this.showTemplateModal = false;
    this.templateMode = null;
  }
  @Watch("showTemplateModal")
  changedShowTemplate(val) {
    this.$nextTick(() => {
      this.statusTemplateModal = val;
    });
  }
  assignPenunjang(val) {
    this.orderItems = val;
    this.showTemplateModal = false;
  }

  tempel() {
    if (!isEmpty(this.orderItems)) {
      appModule.sendErrorAlert(
        "Sudah ada Order " + this.type + " tersedia, tidak bisa menimpa."
      );
    } else {
      this.orderItems = this.paste;
      if (this.type == "lab") {
        storeCopy.clear_copy_lab();
      } else {
        storeCopy.clear_copy_ro();
      }
    }
  }
}
